import useSWR from 'swr';
import ENDPOINTS from '@/constants/apiEndpoints';
import { fetcher } from '@/utils/request';
import useUserInfo from './useUserInfo';

export function usePointsStatus() {
  const { userInfo } = useUserInfo();
  const pointStatus = useSWR<IPointsStatusRes>(
    userInfo?.user_address
      ? [`${ENDPOINTS.pointsStatus}`, userInfo?.user_address]
      : null,
    ([url, address]: [string, string]): Promise<IPointsStatusRes> => {
      return fetcher(
        url,
        {
          method: 'GET'
        },
        false
      );
    },
    {
      revalidateOnFocus: false
    }
  );

  return { pointStatus };
}
